import { Card, Stack } from "@mui/material";
import React, { useRef, useState, useEffect } from "react";
import Camera from "../assets/logo/Vector.png";
import CancelIcon from "@mui/icons-material/Cancel";
import "../App.css";
import UploadIcon from "@mui/icons-material/Upload";
import { Typography } from "@mui/material";

const ImageUploader = ({ passChildData, heading, title, profileImage }) => {
  const FileInputRef = useRef();

  const [selectedFiles, setselectedFiles] = useState([]);

  const FileChangeHandler = (e) => {
    var reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    reader.onloadend = function () {
      var base64data = reader.result;
      setselectedFiles((previous) => [...previous, base64data]);
    };
  };

  useEffect(() => {
    passChildData(selectedFiles);
  }, [selectedFiles]);

  const cardClickHandler = () => {
    if (selectedFiles.length >= 3) {
      alert("The maximum number of file uploads can be 3.");
    } else {
      FileInputRef.current.click();
    }
  };
  const remove = (index) => {
    // console.log(selectedFiles)
    // setselectedFiles(selectedFiles.splice(index, 1))
    let arr = [...selectedFiles];
    arr.splice(index, 1);
    setselectedFiles(arr);
    // console.log('arrr', arr)
    // console.log('indexxx', index)
    // console.log('sldkj', arr.splice(1, 1))
  };

  return (
    <Stack className="image-upload" spacing={1}>
      <Stack className="mb-5">
        <Typography className="field-label">
          {heading ? heading : "Add Images or Videos"}{" "}
        </Typography>
      </Stack>

      <Stack direction="row" spacing={2}>
        {selectedFiles.length
          ? selectedFiles.map((item, index) => (
              <Card className="add-image">
                <CancelIcon
                  className="removeImage"
                  color="error"
                  onClick={() => remove(index)}
                />
                <img
                  src={item}
                  style={{
                    height: "200px",
                    width: "200px",
                    position: "relative",
                    bottom: "29px",
                    objectFit: "contain",
                  }}
                />
              </Card>
            ))
          : null}
        {profileImage && selectedFiles.length >= 1 ? (
          <></>
        ) : (
          <div className="add-image image-upload" onClick={cardClickHandler}>
            <Stack>
              <UploadIcon
                className="category-logo"
                style={{ color: "#A5A4AA" }}
              />
            </Stack>
            <Stack className="t-a-c mt-5" style={{ color: "#A5A4AA" }}>
              {title ? title : "Attach Image or Video"}
            </Stack>
          </div>
        )}
      </Stack>
      <input
        required
        type="file"
        accept="image/png, image/jpeg"
        ref={FileInputRef}
        onChange={FileChangeHandler}
        style={{ display: "none" }}
      />
    </Stack>
  );
};

export default ImageUploader;
